import { AccountSummaryApiModel } from '@api/accounts/models/account.api.model';
import { userPermissionsEnum } from '../enums/user-permissions.enum';

export class AccountSummaryModel {
    id?: number;
    name?: string;
    active?: boolean;
    neptuneOnly?: boolean;
    partnerResellerId?: number;
    preserveData?: boolean;
    ssoProviderId?: number;
    expiryDate?: Date;
    isExpiryDatePast?: boolean;
    createdDate?: Date;
    startDate?: Date;
    userCount?: number;
    permissions?: userPermissionsEnum[];
    hasUiAccess?: boolean;

    constructor(apiEntity?: AccountSummaryApiModel) {
        if (apiEntity) {
            this.constructFromApiEntity(apiEntity);
        } else {
            this.constructDefault();
        }
    }

    /**
     * Constructs this model from the provided API entity
     */
    private constructFromApiEntity(apiEntity: AccountSummaryApiModel): void {
        this.id = apiEntity.id;
        this.name = apiEntity.name;
        this.active = apiEntity.active;
        this.neptuneOnly = apiEntity.neptuneOnly;
        this.partnerResellerId = apiEntity.partnerResellerId;
        this.preserveData = apiEntity.preserveData;
        this.ssoProviderId = apiEntity.ssoProviderId;
        this.expiryDate = new Date(apiEntity.expiryDate);
        this.isExpiryDatePast = this.expiryDate < new Date();
        if (!apiEntity.startDate) {
            this.startDate = new Date(apiEntity.createdDate);
        } else {
            this.startDate = new Date(apiEntity.startDate);
        }
        this.userCount = apiEntity.userCount;
        this.permissions = apiEntity.permissionIds;
        this.hasUiAccess = apiEntity.hasUiAccess;
    }

    /**
     * Constructs the default version of this
     */
    private constructDefault(): void {
        this.id = null;
        this.name = null;
    }
}
